<div class="attachment-viewer-dialog">
  <div class="dialog-header">
    <h2>Attachment</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div *ngIf="isLoading" class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Loading attachment...</span>
    </div>
    <div *ngIf="error" class="error-state">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>
    <div *ngIf="!isLoading && !error && jsonData" class="json-viewer">
      <ui-json-viewer [json]="jsonData" [depth]="2" [showToolbar]="true"></ui-json-viewer>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="close()">Close</button>
  </div>
</div>
